import React, { useEffect, useRef, useState } from "react";
import { useCallback } from 'react';
import InnerLayout from "../../components/layouts/inner-layout";
import search from "../../assets/icons/searchIcon.svg";
import { Link } from 'react-scroll';
import reportsData from "./reports-data";
import { useNavigate } from "react-router-dom";
import { GetFavAction,GetSavedReportsAction,GetTagsAction } from "../../redux/actions/report-action";
import { customReportListAction } from "../../redux/actions/custom-report-action";
import { useDispatch } from "react-redux";
import { 
  ChevronDown, Filter,List,
} from 'lucide-react';
import { FaChartPie,FaStar} from 'react-icons/fa';
import { MdPerson } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { SidebarSection } from "./SidebarSection";
import { SidebarItem } from "./SidebarItem";
import { BsGraphUpArrow} from 'react-icons/bs';
import { FaMoneyBillWave } from "react-icons/fa6";
import { HiDocumentReport } from "react-icons/hi";
import { PiPackageFill } from "react-icons/pi";
import { BiGridVertical } from "react-icons/bi";
import { BiSolidBank } from "react-icons/bi";
import { TbPackages } from "react-icons/tb";
import DashboardCards from "./DashBoardCards";
import ReportTable from "./ReportTable";
import { canCreateAndEditCustomReports } from "../../utils/custom-report-permissions";

const Reports = () => {
  const dispatch = useDispatch();
  const [reportModules, setreportModules] = useState(reportsData);
  const [view, setView] = useState("grid");
  const reportRefs = useRef([]);
  const [addedFav,setAddedFav]=useState([]);
  const [customReports,setCustomReports]=useState([]);
  const [sqlCustomReports,setSqlCustomReports]=useState([]);
  const [tagsData,setTagsData]=useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [showTypes, setShowTypes] = useState(false);
  const [showModules, setShowModules] = useState(false);
  const types = ["All Reports", "Favorites","My Reports", "System Reports"];
  const [activeItem, setActiveItem] = useState('All Reports');
  const navigate = useNavigate();

const [allCardsData, setAllCardsData] = useState([]);
const [cards, setCards] = useState([]);

const formatTimeAgo = (dateString) => {
  if (!dateString) return "recently";
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

function allReports() {
  const transformedReports = [];
  const canEditCustom = canCreateAndEditCustomReports();

  reportsData.forEach(section => {
    section.childrens.forEach(child => {
      // Skip "Create New Report" if user doesn't have permission
      if (child.title === "Create New Report" && !canEditCustom) {
        return;
      }
      const matchingReport = tagsData.find(report => report.name === child.title);
      transformedReports.push({
        title: child.title,
        type: "System",
        description: child.desc,
        tag: matchingReport ? matchingReport.tags : [],
        tagColor: matchingReport ? matchingReport.color : [],
        updated: `${Math.floor(Math.random() * 24)}h ago`,
        path: child.path,
        stared: (addedFav.includes(child.title)),
        combo: child.combo,
        module:child.module_name
      });
    });
  });
  customReports.forEach(element=>{
    const matchingReport = tagsData.find(report => report.name === element);
      transformedReports.push({
        title: element,
        type: "Custom",
        description: "This is a custom report",
        tag: matchingReport ? matchingReport.tags : [],
        tagColor: matchingReport ? matchingReport.color : [],
        updated: `${Math.floor(Math.random() * 24)}h ago`,
        path: `/reports/savedReports?name=${element}`,
        combo: Math.floor(Math.random() * 6) + 1,
        stared: (addedFav.includes(element)),
        module:"Custom"
      });
  })
  // Add SQL Custom Reports
  sqlCustomReports.forEach((report, index) => {
    const matchingReport = tagsData.find(r => r.name === report.name);
    const timeAgo = formatTimeAgo(report.update_date || report.created_date);
    transformedReports.push({
      title: report.name,
      type: "Custom",
      description: report.description || "Custom SQL report",
      tag: matchingReport ? matchingReport.tags : [],
      tagColor: matchingReport ? matchingReport.color : [],
      updated: timeAgo,
      path: `/reports/custom-reports/view/${report.report_id}`,
      combo: (index % 6) + 1,
      stared: (addedFav.includes(report.name)),
      module: "Custom",
      is_shared: report.is_shared,
      report_id: report.report_id
    });
  })
  setAllCardsData(transformedReports); // Store all data
  setCards(transformedReports); // Display all initially
}

const filterCardsByFirstTag = (tagString) => {
  const filtered = allCardsData.filter(card => card.module === tagString);
  setCards(filtered);
};




const filterCardsByWord = (searchWord) => {
  const filtered = allCardsData.filter(card => {
    const lowerSearch = searchWord.toLowerCase();
    const titleMatch = card.title.toLowerCase().includes(lowerSearch);
    const tagMatch = card.tag.some(t => t.toLowerCase().includes(lowerSearch));
    return titleMatch || tagMatch;
  });
  setCards(filtered);
};



useEffect(() => {
    allReports();
  }, []);
const handleItemClick = (title) => {
    setActiveItem(title);
    if(title=='All Reports'){
      setCards(allCardsData);
    }
    if(title=='Favorites'){
      const filtered = allCardsData.filter(
        card => card.stared === true
      );
      setCards(filtered);
      setActiveItem(title);
    }if(title == 'My Reports'){
      const filtered = allCardsData.filter(
        card => card.type === 'User'
      );
      setCards(filtered);
    }if(title == 'System Reports'){
      const filtered = allCardsData.filter(
        card => card.type === 'System'
      );
      setCards(filtered);
    }if(title == 'My Reports'){
      const filtered = allCardsData.filter(
        card => card.type === 'Custom'
      );
      setCards(filtered);
    }
  };
function Sidebar() {
  const iconMapping = {
    "BsGraphUpArrow": BsGraphUpArrow,
    "FaMoneyBillWave":FaMoneyBillWave,
    "PiPackageFill":PiPackageFill,
    "BiSolidBank":BiSolidBank,
    "TbPackages":TbPackages,
    "HiDocumentReport":HiDocumentReport
  };

  return (
    <div className="flex w-full h-full bg-white border-r border-gray-200 flex-col">
      <div className="px-4 py-6 border-b border-D0D5DD">
        <h2 className="text-xlg font-semibold">Reports Hub</h2>
      </div>
      <div className="flex-1 overflow-y-auto py-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
        <SidebarSection>
          <ul className="space-y-2">
          <SidebarItem 
            title="All Reports" 
            icon={FaChartPie} 
            isActive={activeItem === 'All Reports'}
            onClick={async () => handleItemClick('All Reports')}
            badge={allCardsData.length>0?allCardsData.length:"--"}
          />
          <SidebarItem 
            title="Favorites" 
            icon={FaStar } 
            isActive={activeItem === 'Favorites'}
            onClick={async() => {handleItemClick('Favorites')}}
          />
          <SidebarItem 
            title="My Reports" 
            icon={MdPerson} 
            isActive={activeItem === 'My Reports'}
            onClick={() => handleItemClick('My Reports')}
          />
          <SidebarItem 
            title="System Reports" 
            icon={IoMdSettings} 
            isActive={activeItem === 'System Reports'}
            onClick={() => handleItemClick('System Reports')}
          />
          </ul>
        </SidebarSection>
        <SidebarSection title="Modules">
          <ul className="space-y-2">
            {reportsData.map((report) => {
              const IconComponent = iconMapping[report.icon];

              return (
                <li key={report.title}>
                  <Link
                    to={report.title}
                    spy={true}
                    smooth={true}
                    offset={-60}
                    duration={500}
                    className="block"
                  >
                    <SidebarItem
                      title={report.title}
                      icon={IconComponent || HiDocumentReport}
                      isActive={activeItem === report.title}
                      onClick={() => {setActiveItem(report.title);filterCardsByFirstTag(report.type)}}
                    />
                  </Link>
                </li>
              );
            })}
          </ul>
        </SidebarSection>
      </div>
    </div>
  );
}
const SearchBar = () => {
  
  const [searchResults, setSearchResults] = useState([]);

  const debounceRef = useRef(null);

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    
    // Clear the previous timeout
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    
    // Set a new timeout
    debounceRef.current = setTimeout(() => {
      filterCardsByWord(value);
    }, 300);
  };

  return (
    <>
      <div className="w-4/6">
        <div className="flex items-center bg-white border border-D0D5DD rounded-md px-3 py-2 shadow-sm">
          <img src={search} alt="search icon" className="w-4 h-4 mr-2" />
          <input
            type="text"
            placeholder="Search reports..."
            onChange={handleChange}
            value={searchValue}
            autoFocus
            className="w-full outline-none text-sm placeholder-gray-400 border-D0D5DD"
          />
        </div>
      </div>
    </>
  );
};  
useEffect(() => {
    reportRefs.current = reportModules.map(
      (_, i) => reportRefs.current[i] ?? React.createRef()
    );
  }, [reportModules]);
  const [get,setGet]=useState(true);

  useEffect(() => {
    if(get){
      dispatch(GetFavAction ({},onSuccess, onError));
      dispatch(GetSavedReportsAction({}, onSuccess__1, onError));
      dispatch(GetTagsAction({}, onSuccess__2, onError));
      dispatch(customReportListAction(onSuccess__3, onError));
      setGet(false);
    }
   },[get]);

    const onSuccess = (data) => {
      setAddedFav(data?.data?.result ?? []);
    };

    const onSuccess__1 = (data) => {
      setCustomReports(data?.data?.result ?? []);
  };

  const onSuccess__2 = (data) => {
      setTagsData(data?.data?.result ?? []);
  };

  const onSuccess__3 = (data) => {
      setSqlCustomReports(data?.data ?? []);
  };

    const onError = (data) => {
    };

    const combos = {
      1: ["reports-shade1_text", "reports-shade1_bg"],
      2: ["reports-shade2_text", "reports-shade2_bg"],
      3: ["reports-shade3_text", "reports-shade3_bg"],
      4: ["reports-shade4_text", "reports-shade4_bg"],
      5: ["reports-shade5_text", "reports-shade5_bg"],
      6: ["reports-shade6_text", "reports-shade6_bg"]
    };
    useEffect(() => {
    allReports();
  }, []);

  useEffect(()=>{
    allReports();
  },[addedFav,customReports,tagsData,sqlCustomReports]);

return (
  <InnerLayout backBtn={true} list={true} title="Reports">
<div className="flex flex-col md:flex-row w-full h-screen">
  {/* Sidebar */}
  <div className="w-full md:w-[17%] shrink-0 bg-white border-r border-gray-200">
    <Sidebar />
  </div>

  {/* Main content */}
  <div className="w-full md:w-[83%] flex flex-col overflow-hidden bg-gray-50">
    {/* Scrollable content container */}
    <div className="flex-1 overflow-y-auto p-4">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-2">
        <div className="text-2xl font-bold">
          Reports
          <br />
          <span className="text-sm font-normal text-gray-500">Manage and access all your reports</span>
        </div>
        <button className="bg-report-side-bar-hover-text-colour text-white px-4 py-2 rounded-md" disabled>
          + Create Report
        </button>
      </div>

      {/* Filters Row */}
      {/* <div className="flex flex-wrap gap-2 mb-6">
        <SearchBar />
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm">
          All Types
          <ChevronDown size={16} />
        </button>
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm">
          All Modules
          <ChevronDown size={16} />
        </button>
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm">
          <Filter size={16} />
          Filters
        </button>
      </div> */}
      <div className="relative flex flex-wrap gap-2 mb-6">
      <SearchBar />

      {/* All Types Dropdown */}
      <div className="relative">
        <button
          onClick={() => setShowTypes(!showTypes)}
          className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm"
        >
          All Types
          <ChevronDown
            size={16}
            className={`transform transition-transform duration-200 ${
              showTypes ? "rotate-180" : ""
            }`}
          />
        </button>
        <div
          className={`absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded shadow transition-all duration-200 origin-top transform ${
            showTypes
              ? "opacity-100 scale-y-100 translate-y-0"
              : "opacity-0 scale-y-95 -translate-y-2 pointer-events-none"
          }`}
        >
          {types.map((type, idx) => (
            <div
              key={idx}
              className="px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
              onClick={async() => {handleItemClick(type)}}
            >
              {type}
            </div>
          ))}
        </div>
      </div>

      {/* All Modules Dropdown */}
      <div className="relative">
        <button
          onClick={() => setShowModules(!showModules)}
          className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm"
        >
          All Modules
          <ChevronDown
            size={16}
            className={`transform transition-transform duration-200 ${
              showModules ? "rotate-180" : ""
            }`}
          />
        </button>
        <div
          className={`absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded shadow transition-all duration-200 origin-top transform ${
            showModules
              ? "opacity-100 scale-y-100 translate-y-0"
              : "opacity-0 scale-y-95 -translate-y-2 pointer-events-none"
          }`}
        >
          {reportsData.map((mod, idx) => (
            <div
              key={idx}
              className="px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
              onClick={async() => {handleItemClick(mod.title)}}
            >
              {mod.title}
            </div>
          ))}
        </div>
      </div>

      <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm">
        <Filter size={16} />
        Filters
      </button>
    </div>

      {/* View Toggle */}
      <div className="flex border bg-gray-100 border-gray-200 rounded-md w-fit mb-4">
        <button
          className={`flex items-center gap-2 px-4 py-2 text-xs ${
            view === "grid" ? "bg-report-side-bar-hover-text-colour text-white rounded-md" : ""
          }`}
          onClick={() => setView("grid")}
        >
          <BiGridVertical size={16} />
          Grid
        </button>
        <button
          className={`flex items-center gap-2 px-4 py-2 text-xs ${
            view === "list" ? "bg-report-side-bar-hover-text-colour text-white rounded-md" : ""
          }`}
          onClick={() => setView("list")}
        >
          <List size={16} />
          List
        </button>
      </div>

      {/* Main Content - with proper spacing */}
      <div className="pb-20">
        {view === "grid" ? (
          <DashboardCards combos={combos} cards={cards} addedFav={addedFav} setAddedFav={setAddedFav} navigate={navigate} setCards={setCards} canEditCustomReports={canCreateAndEditCustomReports()} onRefreshCustomReports={() => dispatch(customReportListAction(onSuccess__3, onError))} />
        ) : (
          <ReportTable combos={combos} cards={cards} navigate={navigate} setAddedFav={setAddedFav} addedFav={addedFav} setCards={setCards} canEditCustomReports={canCreateAndEditCustomReports()} onRefreshCustomReports={() => dispatch(customReportListAction(onSuccess__3, onError))}/>
        )}
      </div>
    </div>
  </div>
</div>


  </InnerLayout>
);


};

export default Reports;
